import { Api } from '../../Utils/api'
import { CFOP, CstICMS, error99, Fornecedor, GrupoDespesa, NFEntrada, NFEntraItem, NFFilter, ParcelamentoDupPagar, Produto, RegimeTributarioType, RelatorioNF, RetAPI, SubGrupoDespesa, Transportadora } from '../../Utils/Types'
import { DataSearch } from '../../Components/SearchBox/SearchBox'
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'

export type AttributesNFEntrada = {
    fornecedores: Fornecedor[],
    grupoDespesa: GrupoDespesa[],
    subgrupoDespesa: SubGrupoDespesa[],
    transportadoras: Transportadora[],
    regimeTributario: RegimeTributarioType,
    produtos: Produto[],
    cfops: CFOP[],
    csts: CstICMS[],
    naturezas: DataSearch[],
}

export const NotaEntradaService = {

    GetAttributes: async (): Promise<RetAPI> => {
        const resp = await Api('EntradaNF/attributes', 'get', {})

        let retorno: AttributesNFEntrada = { fornecedores: [], grupoDespesa: [], subgrupoDespesa: [], transportadoras: [], regimeTributario: "SN", produtos: [], cfops: [], naturezas: [], csts: [] }

        let produto: Produto = {
            id: 0,
            descricao: '',
            estoque_minimo: 0,
            ativo: false,
            ncm: '',
            cod_cest: '',
            origem_mercadoria: '0',
            tipo: 'P',
            estoque: 0,
            estoque_fisico: 0,
            description: ''
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: retorno
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                switch (resp.data.regime_tributario) {
                    case "SN":
                        retorno.regimeTributario = "SN"
                        break
                    case "LR":
                        retorno.regimeTributario = "LR"
                        break
                    case "MEI":
                        retorno.regimeTributario = "MEI"
                        break
                    case "LP":
                        retorno.regimeTributario = "LP"
                        break
                }

                if (resp.data.cfops) {

                    retorno.cfops = await resp.data.cfops.map((item: any) => {
                        return {
                            id: item.codigo,
                            codigo: item.codigo,
                            description: item.descricao
                        }
                    })
                }

                if (resp.data.csts) {
                    retorno.csts = await resp.data.csts.map((item: any) => {
                        return {
                            id: item.cod_cst,
                            codigo: item.cod_cst,
                            description: item.descricao
                        }
                    })
                }

                if (resp.data.naturezas) {
                    retorno.naturezas = await resp.data.naturezas.map((item: any) => {
                        return {
                            id: item.id,
                            description: item.descricao,
                        }
                    })
                }

                if (resp.data.fornecedores) {
                    retorno.fornecedores = await resp.data.fornecedores.map((item: any) => {
                        return {
                            id: item.id,
                            endereco: item.endereco,
                            bairro: item.bairro,
                            id_cidade: item.id_cidade,
                            cnpj_cpf: item.cnpj_cpf,
                            nome: item.nome,
                            description: item.nome,
                            nome_fantasia: item.nome_fantasia,
                            tipo_pessoa: item.tipo_pessoa,
                            uf: '',
                            cidade: {
                                id: item.id_cidade,
                                description: item.nome_cidade,
                                uf: item.uf,
                                codIBGE: item.id_cidade,
                            },
                            ativo: false,
                        }
                    })
                }

                if (resp.data.transportadoras) {
                    retorno.transportadoras = await resp.data.transportadoras.map((transp: any) => {
                        return {
                            id: transp.id,
                            razao: transp.razao,
                            fantasia: transp.fantasia,
                            endereco: transp.endereco,
                            bairro: transp.bairro,
                            numero: transp.numero,
                            cep: transp.cep,
                            id_cidade: transp.id_cidade,
                            complemento: transp.complemento,
                            tipo_pessoa: transp.tipo_pessoa,
                            doc: transp.cnpj_cpf,
                            ativo: transp.ativo,
                            uf: transp.uf,
                            description: transp.razao
                        }
                    })
                }

                if (resp.data.grupoDespesa) {
                    retorno.grupoDespesa = await resp.data.grupoDespesa.map((grupoDesp: any) => {
                        return {
                            id: grupoDesp.id,
                            descricao: grupoDesp.descricao,
                            id_sgrupo_despesa: grupoDesp.id_sgrupo_despesa,
                            classificacao: grupoDesp.classificacao,
                            id_empresa: grupoDesp.id_empresa,
                            dt_cadastro: grupoDesp.dt_cadastro,
                            id_user_insert: grupoDesp.id_user_insert,
                            dt_last_update: grupoDesp.dt_last_update,
                            id_user_last_update: grupoDesp.id_user_last_update,
                            dh_exclusao: grupoDesp.dh_exclusao,
                            id_user_exclusao: grupoDesp.id_user_exclusao,
                            motivo_exclusao: grupoDesp.motivo_exclusao,
                            description: grupoDesp.descricao
                        }
                    })
                }

                if (resp.data.subgrupoDespesa) {
                    retorno.subgrupoDespesa = await resp.data.subgrupoDespesa.map((subGrupoDesp: any) => {
                        return {
                            id: subGrupoDesp.id,
                            descricao: subGrupoDesp.descricao,
                            id_empresa: subGrupoDesp.id_empresa,
                            dt_cadastro: subGrupoDesp.dt_cadastro,
                            id_user_insert: subGrupoDesp.id_user_insert,
                            dt_last_update: subGrupoDesp.dt_last_update,
                            id_user_last_update: subGrupoDesp.id_user_last_update,
                            dh_exclusao: subGrupoDesp.dh_exclusao,
                            id_user_exclusao: subGrupoDesp.id_user_exclusao,
                            motivo_exclusao: subGrupoDesp.motivo_exclusao,
                            description: subGrupoDesp.descricao
                        }
                    })
                }

            }

            /*
            retorno.produtos = await resp.data.produtos.map( (item: any) => {                 
                return {
                    id               : item.id,
                    descricao        : item.descricao,
                    description      : item.descricao,
                    estoque_minimo   : 0,
                    ativo            : true,
                    ncm              : '',
                    cod_cest         : '',
                    origem_mercadoria: item.origem_mercadoria,
                    tipo             : 'P',
                    estoque          : 0,
                    estoque_fisico   : 0,
                    urlImage         : item.url_image,
                    preco_c          : item.preco_c,
                    pICMS            : item.pICMS,
                    codStPisCofins   : item.cst_pis_cofins,
                    cfopEntDentro    : item.cfop_entrada_dentro,
                    cfoEntFora       : item.cfop_entrada_fora,
                    cstIcmsDentro    : item.cst_icms_dentro,
                    cstIcmsFora      : item.cst_icms_fora,
                    pPis             : item.aliq_pis,
                    pCofins          : item.aliq_cofins,
                    saldo            : item.estoque_fisico,
                }
            })
                */

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: retorno
            }
        }

        return {
            error: false,
            data: retorno
        }

    },

    Save: async (notaFiscal: NFEntrada): Promise<RetAPI> => {
        const resp = await Api('EntradaNF/save', 'post', notaFiscal)

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                id: resp.data.nf.id,
                error: false,
                msg: '',
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
            }
        }

    },

    CadastrarItem: async (item: NFEntraItem): Promise<RetAPI> => {

        const resp = await Api('EntradaNF/item/save', 'post', item)

        /*
        const retorno: RetAPI = {
            error: false,
            msg: '',
        }
            */

        const nfItem: NFEntraItem = {
            id: 0,
            nitem: 0,
            id_produto: 0,
            descricao: '',
            qtd: 0,
            unid_c: '',
            contem: 0,
            vl_unit: 0,
            vl_tot: 0
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: nfItem
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                nfItem.id = resp.data.item.id
                nfItem.nitem = resp.data.item.nitem
                nfItem.id_produto = resp.data.item.id_produto
                nfItem.descricao = resp.data.item.desc_prod
                nfItem.qtd = resp.data.item.qtd
                nfItem.unid_c = resp.data.item.unid_c
                nfItem.contem = resp.data.item.contem
                nfItem.vl_unit = resp.data.item.vl_unit
                nfItem.vl_tot = resp.data.item.vl_total
                nfItem.vl_desc = resp.data.item.vl_desc
                nfItem.vl_seg = resp.data.item.vl_seg
                nfItem.vl_out = resp.data.item.vl_out
                nfItem.vl_frete = resp.data.item.vl_frete
                nfItem.vl_bc_pis = resp.data.item.vl_bc_pis
                nfItem.aliq_pis = resp.data.item.aliq_pis
                nfItem.vl_pis = resp.data.item.vl_pis
                nfItem.cod_st_pis = resp.data.item.cod_st_pis
                nfItem.vl_bc_cofins = resp.data.item.vl_bc_cofins
                nfItem.aliq_cofins = resp.data.item.aliq_cofins
                nfItem.vl_cofins = resp.data.item.vl_cofins
                nfItem.vl_bc_icms = resp.data.item.vl_bc_icms
                nfItem.aliq_icms = resp.data.item.aliq_icms
                nfItem.aliq_red_icms = resp.data.item.aliq_red_icms
                nfItem.vl_icms = resp.data.item.vl_icms
                nfItem.vl_bc_ipi = resp.data.item.vl_bc_ipi
                nfItem.aliq_ipi = resp.data.item.aliq_ipi
                nfItem.vl_ipi = resp.data.item.vl_ipi
                nfItem.vl_bc_st = resp.data.item.vl_bc_st
                nfItem.aliq_st = resp.data.item.aliq_st
                nfItem.vl_st = resp.data.item.vl_st
                nfItem.mod_bc_st = resp.data.item.mod_bc_st
                nfItem.pmvast = resp.data.item.pmvast
                nfItem.origem = resp.data.item.origem
                nfItem.cst_icms = resp.data.item.cst_icms
                nfItem.cfop = resp.data.item.cfop
                nfItem.indtot = resp.data.item.indtot

            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: nfItem
            }
        }

        return {
            error: false,
            data: nfItem
        }

    },

    ConfirmarNf: async (id_nf: number, parcelamento: any): Promise<RetAPI> => {

        const resp = await Api('EntradaNF/confirm', 'put', { id_nf, parcelamento })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: resp.data.msg || '',
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
            }
        }

    },

    HabilitarEditNf: async (id_nf: number): Promise<RetAPI> => {

        const resp = await Api('EntradaNF/edit', 'put', { id_nf })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: '',
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
            }
        }
    },

    Delete: async (id_nf: number, nitem: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        if (senha != '') {
            senha = base64_encode(senha + '-' + random)
        }

        const resp = await Api(`EntradaNF/item/delete?id_nf=${id_nf}&nitem=${nitem}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
            data: resp.data.itens
        }

    },

    LocalizarItemNF: async (id_nf: number, nitem: number): Promise<RetAPI> => {

        const resp = await Api('EntradaNF/item/find', 'get', { id_nf, nitem })
        const nfAttributes: NFEntraItem = {
            id: 0,
            nitem: 0,
            id_produto: 0,
            descricao: '',
            qtd: 0,
            unid_c: '',
            contem: 0,
            vl_unit: 0,
            vl_tot: 0,
            vl_desc: 0,
            vl_seg: 0,
            vl_out: 0,
            vl_frete: 0,
            vl_bc_pis: 0,
            aliq_pis: 0,
            vl_pis: 0,
            cod_st_pis: '',
            vl_bc_cofins: 0,
            aliq_cofins: 0,
            vl_cofins: 0,
            vl_bc_icms: 0,
            aliq_icms: 0,
            aliq_red_icms: 0,
            vl_icms: 0,
            vl_bc_ipi: 0,
            aliq_ipi: 0,
            vl_ipi: 0,
            vl_bc_st: 0,
            aliq_st: 0,
            vl_st: 0,
            mod_bc_st: 0,
            pmvast: 0,
            origem: 0,
            cst_icms: '',
            cfop: '',
            indtot: 0,
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: nfAttributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (nfAttributes) {

                    nfAttributes.id = resp.data.nitem.id
                    nfAttributes.nitem = resp.data.nitem.nitem
                    nfAttributes.id_produto = resp.data.nitem.id_produto
                    nfAttributes.descricao = resp.data.nitem.desc_prod
                    nfAttributes.qtd = resp.data.nitem.qtd
                    nfAttributes.unid_c = resp.data.nitem.unid_c
                    nfAttributes.contem = resp.data.nitem.contem
                    nfAttributes.vl_unit = resp.data.nitem.vl_unit
                    nfAttributes.vl_tot = resp.data.nitem.vl_total
                    nfAttributes.vl_desc = resp.data.nitem.vl_desc
                    nfAttributes.vl_seg = resp.data.nitem.vl_seg
                    nfAttributes.vl_out = resp.data.nitem.vl_out
                    nfAttributes.vl_frete = resp.data.nitem.vl_frete
                    nfAttributes.vl_bc_pis = resp.data.nitem.vl_bc_pis
                    nfAttributes.aliq_pis = resp.data.nitem.aliq_pis
                    nfAttributes.vl_pis = resp.data.nitem.vl_pis
                    nfAttributes.cod_st_pis = resp.data.nitem.cod_st_pis
                    nfAttributes.vl_bc_cofins = resp.data.nitem.vl_bc_cofins
                    nfAttributes.aliq_cofins = resp.data.nitem.aliq_cofins
                    nfAttributes.vl_cofins = resp.data.nitem.vl_cofins
                    nfAttributes.vl_bc_icms = resp.data.nitem.vl_bc_icms
                    nfAttributes.aliq_icms = resp.data.nitem.aliq_icms
                    nfAttributes.aliq_red_icms = resp.data.nitem.aliq_red_icms
                    nfAttributes.vl_icms = resp.data.nitem.vl_icms
                    nfAttributes.vl_bc_ipi = resp.data.nitem.vl_bc_ipi
                    nfAttributes.aliq_ipi = resp.data.nitem.aliq_ipi
                    nfAttributes.vl_ipi = resp.data.nitem.vl_ipi
                    nfAttributes.vl_bc_st = resp.data.nitem.vl_bc_st
                    nfAttributes.aliq_st = resp.data.nitem.aliq_st
                    nfAttributes.vl_st = resp.data.nitem.vl_st
                    nfAttributes.mod_bc_st = resp.data.nitem.mod_bc_st
                    nfAttributes.pmvast = resp.data.nitem.pmvast
                    nfAttributes.origem = resp.data.nitem.origem
                    nfAttributes.cst_icms = resp.data.nitem.cst_icms
                    nfAttributes.cfop = resp.data.nitem.cfop
                    nfAttributes.indtot = resp.data.nitem.indtot

                }

            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: nfAttributes
            }
        }

        return {
            error: false,
            data: nfAttributes
        }

    },

    FiltrarNf: async (datai: string, dataf: string, id_fornecedor: number, status: string): Promise<RetAPI> => {

        const resp = await Api('EntradaNF/filter', 'get', { datai, dataf, id_fornecedor, status })
        const nf: NFFilter[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: nf
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.notas.map((item: any) => {

                    const duplicatasList: ParcelamentoDupPagar[] = []
                    item.duplicatas?.map( (duplicata: any) => {
                        duplicatasList.push(
                            {
                               id: duplicata.id,
                                num_doc: duplicata.num_doc,
                                serie: duplicata.serie,
                                valor: duplicata.valor,
                                id_fornecedor: duplicata.id_fornecedor,
                                id_grupo_despesa: duplicata.id_grupo_despesa,
                                id_subgrupo_despesa: duplicata.id_subgrupo_despesa,
                                dtEmissao: duplicata.dt_cadastro,
                                dt_vencimento: duplicata.dt_vencimento,
                                observacao: duplicata.observacao,
                                nomeFornecedor: "" 
                            }
                        )
                    } )

                    return nf.push({
                        id: item.id,
                        dt_emissao: item.dt_emissao,
                        dt_chegada: item.dt_chegada,
                        id_fornecedor: item.id_fornecedor,
                        id_empresa: item.id_empresa,
                        indPag: item.indPag,
                        vl_desconto: item.vl_desconto,
                        vl_frete: item.vl_frete,
                        vl_outras: item.vl_outras,
                        vl_seguro: item.vl_seguro,
                        vl_produtos: item.vl_produtos,
                        vl_ipi: item.vl_ipi,
                        vl_nf: item.vl_nf,
                        vl_bc_icms: item.vl_bc_icms,
                        v_icms: item.v_icms,
                        vl_bc_st: item.vl_bc_st,
                        vl_st: item.vl_st,
                        vl_pis: item.vl_pis,
                        vl_cofins: item.vl_cofins,
                        id_transp: item.id_transp,
                        modelo: item.modelo,
                        serie: item.serie,
                        num_nf: item.num_nf,
                        fin_nfe: item.fin_nfe,
                        id_nat_op: item.id_nat_op,
                        id_user_insert: item.id_user_insert,
                        dt_cadastro: item.dt_cadastro,
                        id_user_last_update: item.id_user_last_update,
                        dh_last_update: item.dh_last_update,
                        dh_confirm_nf: item.dh_confirm_nf,
                        id_user_confirm_nf: item.id_user_confirm_nf,
                        nome_fantasia: item.nome_fantasia,
                        name_user_insert: item.name_user_insert,
                        duplicatasPagarList: duplicatasList,

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: nf
            }
        }

        return {
            error: false,
            data: nf
        }

    },

    FilterTributes: async (id_prod: number, id_fornecedor: number): Promise<RetAPI> => {
        const resp = await Api('Produto/tributes', 'get', { id_prod, id_fornecedor })
        const trib: any = {
            id: 0,
            descricao: '',
            pICMS: 0,
            pPIS: 0,
            pCOFINS: 0,
            cstPisCofins: '',
            cfop: '',
            cst: '',
            description: ''
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: trib

                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (trib) {

                    trib.id = resp.data.tributos.id
                    trib.descricao = resp.data.tributos.descricao
                    trib.pICMS = resp.data.tributos.pICMS
                    trib.pPIS = resp.data.tributos.pPIS
                    trib.pCOFINS = resp.data.tributos.pCOFINS
                    trib.cstPisCofins = resp.data.tributos.cst_pis_cofins
                    trib.cfop = resp.data.tributos.cfop
                    trib.cst = resp.data.tributos.cst
                    trib.description = resp.data.tributos.descricao
                }

            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: trib
            }

        }

        return {
            error: false,
            data: trib
        }
    },

    ExcluirDupPagar: async (idDup: number) => {

        const resp = await Api('EntradaNF/DupPagar/Delete?id_dup='+idDup, 'delete', {})

        if (resp.data){
            if (resp.data.error === "1"){
                return { 
                    error: true,
                    msg: resp.data.msg,            
                }
            }
        }else{
            return { 
                error: true,
                msg: "Nenhuma informação retornada",            
            }
        }

        return {
            error: false,
            msg: "",            
        }
    },

    SalvarDupPagar: async (idNF: number, dupPagar: ParcelamentoDupPagar) : Promise<RetAPI>  =>{

        const param = {
            num_doc: dupPagar.num_doc,
            serie: dupPagar.serie,
            valor: dupPagar.valor, 
            id_nf: idNF, 
            id_fornecedor: dupPagar.id_fornecedor, 
            id_gdespesa: dupPagar.id_grupo_despesa, 
            id_sgdespesa: dupPagar.id_subgrupo_despesa, 
            data_emissao: dupPagar.dtEmissao, 
            data_vencimento: dupPagar.dt_vencimento, 
            observacao: dupPagar.observacao
        }

        const resp = await Api('EntradaNF/DupPagar/Save', 'post', param)

        if (resp.data){
            if (resp.data.error === "1"){
                return { 
                    error: true,
                    msg: resp.data.msg,            
                }
            }
        }else{
            return { 
                error: true,
                msg: "Nenhuma informação retornada",            
            }
        }

        return {
            error: false,
            msg: "",            
        }

    },

    ExcluirNF: async (id_nf: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api('EntradaNF/excluir?id_nf='+id_nf+"&motivo="+motivo+"&senha="+senha, 'delete', { id_nf })

        if (resp.data && resp.data.error === "1"){
            return {
                      error: true,
                      msg: resp.data.msg,
                    }
        }

        return {
            error: false,
            msg: "",
        }
    },

    BuscarNF: async (id_nf: any): Promise<RetAPI> => {

        const resp = await Api('EntradaNF/find', 'get', { id_nf })

        const attributes: RelatorioNF = {
            id: 0,
            dt_emissao: '',
            dt_chegada: '',
            id_fornecedor: 0,
            id_empresa: 0,
            indPag: 0,
            vl_desconto: 0,
            vl_frete: 0,
            vl_outras: 0,
            vl_seguro: 0,
            vl_produtos: 0,
            vl_ipi: 0,
            vl_nf: 0,
            vl_bc_icms: 0,
            v_icms: 0,
            vl_bc_st: 0,
            vl_st: 0,
            vl_pis: 0,
            vl_cofins: 0,
            id_transp: 0,
            modelo: 0,
            serie: 0,
            num_nf: 0,
            fin_nfe: 0,
            id_nat_op: 0,
            id_user_insert: 0,
            dt_cadastro: '',
            id_user_last_update: 0,
            dh_last_update: '',
            dh_confirm_nf: '',
            id_user_confirm_nf: 0,
            mod_frete: 9,
            nome_fantasia: '',
            nome_user_insert: '',
            nome_transp: '',
            itensNF: [],
            dupPagarList: [],
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0' && resp.data.nf) {
                // Atribuição direta dos valores de `nf` a `attributes`
                Object.assign(attributes, resp.data.nf)

                // Verifique se 'itens' é um array antes de fazer a cópia
                if (Array.isArray(resp.data.nf.itens)) {
                    attributes.itensNF = resp.data.nf.itens.map((item: any) => ({
                        ...item
                    }))
                }

                if (resp.data.nf.duplicatas){                                    
                    resp.data.nf.duplicatas.map( (duplicata: any) => {
                        attributes.dupPagarList?.push(
                            {
                               id: duplicata.id,
                                num_doc: duplicata.num_doc,
                                serie: duplicata.serie,
                                valor: duplicata.valor,
                                id_fornecedor: duplicata.id_fornecedor,
                                id_grupo_despesa: duplicata.id_grupo_despesa,
                                id_subgrupo_despesa: duplicata.id_subgrupo_despesa,
                                dtEmissao: duplicata.dt_cadastro,
                                dt_vencimento: duplicata.dt_vencimento,
                                observacao: duplicata.observacao,
                                nomeFornecedor: duplicata.nome_fornecedor 
                            }
                        )
                    } )

                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }
        }

        return {
            error: false,
            msg: "",
            data: attributes,
        }
    },
}